import { render, staticRenderFns } from "./EditMutation.vue?vue&type=template&id=20619772&scoped=true"
import script from "./EditMutation.vue?vue&type=script&lang=js"
export * from "./EditMutation.vue?vue&type=script&lang=js"
import style0 from "./EditMutation.vue?vue&type=style&index=0&id=20619772&prod&lang=css"
import style1 from "./EditMutation.vue?vue&type=style&index=1&id=20619772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20619772",
  null
  
)

export default component.exports